<template>
  <div class="review_section">
    <div class="container">
      <div class="statistic">
        <div class="row">
          <div class="col-md-6">
            <div class="lg_st">
              <div class="numb">4.7</div>
              <div class="star">
                <div class="star_wrap">
                  <i class="bx bxs-star"></i>
                  <i class="bx bxs-star"></i>
                  <i class="bx bxs-star"></i>
                  <i class="bx bxs-star"></i>
                  <i class="bx bxs-star-half"></i>
                </div>
                <span>Based on 300+ reviews</span>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="row">
              <div class="col-6">
                <div class="sm_st">
                  <div class="social_st">
                    <i class="bx bxl-google-plus"></i>
                  </div>
                  <span>4.7</span>
                </div>
              </div>
              <div class="col-6">
                <div class="sm_st">
                  <div class="social_st">
                    <i class="bx bxl-facebook"></i>
                  </div>
                  <span>4.7</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="review_user">
        <div class="row">
          <div class="col-md-6">
            <div class="user_box">
              <div class="img_user">
                <img src="~@/assets/fav.png" alt="">
              </div>
              <div class="text_user">
                <span class="iconsqte">
                  <i class='bx bxs-quote-left'></i>
                </span>
                <p>Helt utrolig hvor god jobb dere gjør! Jeg har aldri trodd at dere skulle få bilen så bra etter flere år med kjøring til stall med hest utstyr i bilen, skjoldete/flekkete seter som jeg aldri har klart å få ren selv om jeg har prøvd flere rens/vask. Den ser jo helt ny ut!! Med voksingen dere har gjort, så er det nok at jeg bare spyler så ser den like fin og ren ut. Innvendig impregnering av seter gjør at jeg nå slipper å få flekker i setene, det er bare å tørke av. Tidligere var det nok at noen satte seg inn med våte klær, så ble det flekker som ikke gikk bort. Pollenfilter er rengjort, viktig for meg som har pollenallergi. Jeg er bare helt MEGAFORNØYD! Tusen takk, jeg føler jeg har fått meg ny bil igjen! Anbefales, dere vil ikke angre - Virkelig profesjonelt arbeid som utføres. God investering, gir verdiøkning på bilen :o)
                </p>
                <strong class="name_user">A. R. SAND</strong>
              </div>
            </div>
          </div>
           <div class="col-md-6">
            <div class="user_box">
              <div class="img_user">
                <img src="~@/assets/fav.png" alt="">
              </div>
              <div class="text_user">
                <span class="iconsqte">
                  <i class='bx bxs-quote-left'></i>
                </span>
                <p>Bilpleiesenteret Tempe AS utfører service, kundebehandling og bilpleietjenester av ypperste kvalitet hver eneste gang! Jeg har hatt bilen min hos dem flere ganger, og det er som å ta med en ny bil hjem ved hvert besøk. I tillegg fikset de skinnet på mine lenestoler som jeg trodde var ødelagte for godt og ikke kom til å se bra ut igjen. Jeg kan anbefale Bilpleiesenteret Tempe AS på det sterkeste.
                </p>
                <strong class="name_user">L. S. ALEKSANDERSEN</strong>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="user_box">
              <div class="img_user">
                <img src="~@/assets/fav.png" alt="">
              </div>
              <div class="text_user">
                <span class="iconsqte">
                  <i class='bx bxs-quote-left'></i>
                </span>
                <p>Tok en "Full pakke" på bilen (sort BMW 335d) etter en lang trøndervinter med mye salting og svevestøv. Folkene på PD gjorde en fantastisk jobb med bilen. Inn- og utvendig vask, vask av motorrom og polering. I tillegg ble slitasje på skinnet på førersetet reparert og farget opp (måtte gjøres to ganger, men kommunikasjonen med eieren var meget god og arbeidet ble utført raskt). Klar anbefaling!
                </p>
                <strong class="name_user">M. BENDIXEN</strong>
              </div>
            </div>
          </div>
           <div class="col-md-6">
            <div class="user_box">
              <div class="img_user">
                <img src="~@/assets/fav.png" alt="">
              </div>
              <div class="text_user">
                <span class="iconsqte">
                  <i class='bx bxs-quote-left'></i>
                </span>
                <p>Byens beste, uten tvil! Man blir alltid møtt med et smil. Alltid hyggelige og veldig serviceinnstilt. Kjærlighet for det de driver med og det vises i resultatet. Hatt bilen inne til både lakkforsegling og shining, alltid upåklagelig resultat og bilen blir som ny. Anbefales på det sterkeste</p>
                <strong class="name_user">A. LOHSE</strong>
              </div>
            </div>
          </div>
           <div class="col-md-6">
            <div class="user_box">
              <div class="img_user">
                <img src="~@/assets/fav.png" alt="">
              </div>
              <div class="text_user">
                <span class="iconsqte">
                  <i class='bx bxs-quote-left'></i>
                </span>
                <p>Helt utrolig hvor god jobb dere gjør! Jeg har aldri trodd at dere skulle få bilen så bra etter flere år med kjøring til stall med hest utstyr i bilen, skjoldete/flekkete seter som jeg aldri har klart å få ren selv om jeg har prøvd flere rens/vask. Den ser jo helt ny ut!! Med voksingen dere har gjort, så er det nok at jeg bare spyler så ser den like fin og ren ut. Innvendig impregnering av seter gjør at jeg nå slipper å få flekker i setene, det er bare å tørke av. Tidligere var det nok at noen satte seg inn med våte klær, så ble det flekker som ikke gikk bort. Pollenfilter er rengjort, viktig for meg som har pollenallergi. Jeg er bare helt MEGAFORNØYD! Tusen takk, jeg føler jeg har fått meg ny bil igjen! Anbefales, dere vil ikke angre - Virkelig profesjonelt arbeid som utføres. God investering, gir verdiøkning på bilen :o)
                </p>
                <strong class="name_user">A. R. SAND</strong>
              </div>
            </div>
          </div>
           <div class="col-md-6">
            <div class="user_box">
              <div class="img_user">
                <img src="~@/assets/fav.png" alt="">
              </div>
              <div class="text_user">
                <span class="iconsqte">
                  <i class='bx bxs-quote-left'></i>
                </span>
                <p>Bilpleiesenteret Tempe AS utfører service, kundebehandling og bilpleietjenester av ypperste kvalitet hver eneste gang! Jeg har hatt bilen min hos dem flere ganger, og det er som å ta med en ny bil hjem ved hvert besøk. I tillegg fikset de skinnet på mine lenestoler som jeg trodde var ødelagte for godt og ikke kom til å se bra ut igjen. Jeg kan anbefale Bilpleiesenteret Tempe AS på det sterkeste.
                </p>
                <strong class="name_user">L. S. ALEKSANDERSEN</strong>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "reviewArea",
};
</script>
<style lang="scss" xscoped>
.review_section {
  padding: 80px 0px;
  .lg_st {
    display: flex;
    align-items: center;
    .numb {
      font-size: 96px;
      font-weight: 700;
      text-transform: uppercase;
      line-height: 1.1;
      margin: 0;
      color: white;
      vertical-align: baseline;
      font-style: normal;
    }
    .star {
      padding-left: 20px;
      i {
        color: var(--active_color);
        font-size: 20px;
      }
      span {
        font-size: 15px;
        font-weight: 400;
        display: block;
        padding-top: 4px;
      }
    }
  }
  .sm_st {
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: flex-end;
    .social_st {
      width: 64px;
      height: 64px;
      background-color: var(--active_color);
      color: black;
      font-size: 50px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 100%;
      margin-right: 20px;
    }
    span {
      font-size: 2rem;
      font-weight: 700;
      text-transform: uppercase;
      line-height: 1.1;
      margin: 0;
      color: white;
      vertical-align: baseline;
      font-style: normal;
    }
  }
  // 
  .review_user{
    padding-top: 90px;
  }
  .user_box{
    display: flex;
    align-items: flex-start;
    border-bottom: 2px solid white;
    padding-top: 30px;
    padding-bottom: 40px;
    height: 100%;
    transition: 0.3s ease-in-out;
    &:hover{
     border-bottom: 2px solid var(--active_color); 
    }
    .img_user{
     flex: 0 0 90px;
     padding-top: 40px;
      img{
        object-fit: contain;
        width: 90px;
        height: 90px;
        border-bottom: 2px solid var(--active_color);
      }
    }
    .text_user{
    padding-left: 50px;
    padding-right: 50px;
        .iconsqte{
      text-align: left;
    display: block;
    padding-top: 25px;
    color: var(--active_color);
    margin-bottom: 8px;
    i{
      font-size: 20px;
    }
    }
    p{
      line-height: 1.4em;
      font-size: 1.1em;
      margin: 0;
    margin-bottom: 20px;
    text-align: left;
        font-family: 'Roboto', sans-serif;
        font-weight: 300;
        color: white;
        font-style: normal;
    }
    }
  }
}
</style>
